<template>
  <section>
    <p v-if="displayError" class="error-box"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ displayError }}</p>
    <div v-if="isLoading" class="loading-spinner">
      <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
    </div>
    <section v-if="customerInfo.id">
      <h1>{{ human_readable_name(customerInfo) }}</h1>
      <div v-if="customerInfo.statutar">statutární orgán: {{ customerInfo.statutar }}</div>

      <div>

        <div class="row">
          <div class="col-md-2">
            Klientské číslo
          </div>
          <div class="col-md-10">
            {{ customerInfo.id }}
            <br>
            <span id="grey-note">slouží zároveň jako variabilní symbol pro platby</span>
          </div>
        </div>

        <div class="row" v-if="customerInfo.ten">
          <div class="col-md-2">
            IČO
          </div>
          <div class="col-md-10">
            {{ customerInfo.ten }}
          </div>
        </div>

        <div class="row" v-if="customerInfo.regon">
          <div class="col-md-2">
            DIČ
          </div>
          <div class="col-md-10">
            {{ customerInfo.regon }}
          </div>
        </div>

        <div class="row">
          <div class="col-md-2">
            Telefon
          </div>
          <div class="col-md-10">

            <div v-for="(pn, idx) in customerInfo.phoneNumbers" :key="pn.phone">
              {{ pn.phone }}
              <span v-if="pn.typ_sml == 0 || pn.typ_tech == 0">
                <span v-if="pn.typ_sml">✆ smluvní</span>
                <span v-if="pn.typ_tech">✆ technický</span>
              </span>
              <span v-if="pn.name"> ({{pn.name}})</span>
              <div v-if="pn.verified_as_of"> ✅ číslo ověřeno {{ human_readable_date(pn.verified_as_of) }}</div>
              <div v-else>
                číslo ještě není ověřeno
                <br/>
                <!-- <button class="btn btn-outline-primary" v-on:click="triggerPhoneNumberVerification(idx)" :disabled="pn.verificationTriggered">
                  <span>Odeslat SMS pro ověření</span>
                </button> -->
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-2">
            E-mail
          </div>
          <div class="col-md-10">
            <div v-for="(e, idx) in customerInfo.emailAddresses" :key="e.email">
              <code>{{ e.email }}</code>
              &nbsp;
              <span v-if="e.typ_sml == 0 || e.typ_f == 0 || e.typ_tech == 0 || e.typ_sam == 0">
                <span v-if="e.typ_sml">📧 smluvní</span>
                <span v-if="e.typ_f">📧 fakturační</span>
                <span v-if="e.typ_tech">📧 technický</span>
                <span v-if="e.typ_sam">📧 přístup do samoobsluhy</span>
              </span>
              <span v-if="e.note"> ({{e.note}})</span>
              <div v-if="e.verified_as_of"> ✅ adresa ověřena {{ human_readable_date(e.verified_as_of) }}</div>
              <div v-else>
                adresa ještě není ověřena
                <br/>
                <!-- <button class="btn btn-outline-primary" v-on:click="triggerEmailAddressVerification(idx)" :disabled="e.verificationTriggered">
                  <span v-if="!e.verificationTriggered">Odeslat e-mail pro ověření</span>
                  <span v-else>Ověřovací e-mail odeslán</span>
                </button> -->
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-2">
            <span v-if="customerInfo.type == 1">Sídlo</span>
            <span v-else>Trvalé bydliště</span>
          </div>
          <div class="col-md-10">
            <div>{{ customerInfo.address }}</div>
            <div>{{ customerInfo.zip }} {{ customerInfo.city }}</div>
            <div>{{ country_name(customerInfo.countryid) }}</div>
          </div>
        </div>

        <div class="row" v-if="customerInfo.post_address">
          <div class="col-md-2">
            Doručovací adresa
          </div>
          <div class="col-md-10">
            <div v-if="customerInfo.post_name">{{ customerInfo.post_name }}</div>
            <div>{{ customerInfo.post_address }}</div>
            <div>{{ customerInfo.post_zip }} {{ customerInfo.post_city }}</div>
            <div>{{ country_name(customerInfo.post_countryid) }}</div>
          </div>
        </div>

        <div class="row" v-if="customerInfo.inv_address">
          <div class="col-md-2">
            Fakturační adresa
          </div>
          <div class="col-md-10">
            <div v-if="customerInfo.inv_name">{{ customerInfo.inv_name }}</div>
            <div>{{ customerInfo.inv_address }}</div>
            <div>{{ customerInfo.inv_zip }} {{ customerInfo.inv_city }}</div>
            <div>{{ country_name(customerInfo.inv_countryid) }}</div>
          </div>
        </div>

        <div class="row" v-if="customerInfo.bank1">
          <div class="col-md-2">
            Číslo účtu
          </div>
          <div class="col-md-10">
            {{ customerInfo.bank1 }}
            <span v-if="customerInfo.bank2"> / {{ customerInfo.bank2 }}</span>
          </div>
        </div>

        <div class="row" v-if="customerInfo.oku_list && customerInfo.oku_list.length > 0" >
          <div class="col-md-2">
            Ověřovací kód účastníka
          </div>
          <div class="col-md-10">
            <div v-if="!showFullOKU" @click="OKUclicked()">
              <span class="monospace">{{customerInfo.oku_list[0].oku.substr(0,3)}}</span> ... <a href="#">zobrazit</a>
            </div>
            <div v-else>
              <div v-for="oku in customerInfo.oku_list" :key="oku.oku">
                <span class="monospace">{{oku.oku}}</span>
                <span v-if="customerInfo.oku_list.length > 1">pro {{oku.service_name}}</span>
              </div>
            </div>
          </div>
        </div>

      </div>

      <!-- Modal "e-mail odeslán" -->
      <div class="modal fade" id="odeslanoModal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <form>
              <div class="modal-header">
                <h4>Ověřovací e-mail odeslán</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
              </div>
              <div class="modal-body">
                <p>
                  Zpráva s jednorázovým ověřovacím odkazem byla odeslána na adresu <code id="naAdresu"></code>.
                  Postupujte prosím podle instrukcí ve zprávě.
                </p>
                <p>
                  <small>
                    Doručení je zpravidla okamžité. V ojedinělých případech může ale trvat až 20 minut. Zkontrolujte také prosím složku
                    "spam" nebo "hromadná pošta".
                  </small>
                </p>
              </div>
              <div class="modal-footer">
                <div class="d-flex w-100">
                  <div class="flex-grow-1 text-left">
                  </div>
                  <div>
                    <button type="button" class="btn btn-primary" data-dismiss="modal">OK</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <!-- Modal "ověření telefonního čísla" -->
      <div v-if="showVerifyPhoneNumberIdx !== null">
        <verifyPhoneNumber
          :index="showVerifyPhoneNumberIdx"
          @finished="finishedPhoneNumberVerification()"
          @verified="successfulPhoneNumberVerification()"
        />
      </div>

    </section>

    <!-- Nutný zlo pro autofocus (+numerickej touchapd) na mobilním safari -->
    <input type="text" id="tajnej" tabindex="-1">

  </section>
</template>

<script>
import CustomerResource from '../backend-resources/customer-resource'
import moment from 'moment'
import $ from 'jquery';
import VerifyPhoneNumber from './VerifyPhoneNumber.vue';

export default {
  data () {
    return {
      customerInfo: {},
      displayError: null,
      isLoading: false,
      showFullOKU: false,
      showVerifyPhoneNumberIdx: null
    }
  },
  components: {
    verifyPhoneNumber: VerifyPhoneNumber
  },
  created: function () {
    this.load()
  },
  methods: {
    load: function () {
      this.isLoading = true
      CustomerResource.get().then((response) => {
        this.customerInfo = response.data
        this.displayError = null
        this.isLoading = false
      }).catch((error) => {
        this.displayError = error.response.status + ' ' + error.response.statusText
        this.isLoading = false
      })
    },
    human_readable_name: function (ci) {
      return ci.degree1 + ' ' + ci.name + ' ' + ci.lastname + ' ' + ci.degree2 +
        ((ci.name || ci.lastname) && ci.bussinesname ? ' - ' : '') +
        (ci.bussinesname ? ci.bussinesname : '')
    },
    human_readable_date: function (yyyymmdd) {
      let m = moment(yyyymmdd)
      return m.isValid() ? m.format('D.M.Y') : yyyymmdd
    },
    country_name: function (countryid) {
      let c = this.customerInfo.countries
      if (!c) return ''
      return c[countryid]
    },
    OKUclicked: function () {
      this.showFullOKU = true
      CustomerResource.recordOKUdisplay()
    },
    triggerEmailAddressVerification: function (addrIndex) {
      const emailTo = this.customerInfo.emailAddresses[addrIndex].email;
      CustomerResource.sendValidationEmail(addrIndex).then(() => {
        this.$set(this.customerInfo.emailAddresses[addrIndex], 'verificationTriggered', true)
        $('#odeslanoModal #naAdresu').text(emailTo);
        $('#odeslanoModal').modal('show')
      }).catch((e) => {
        alert(`Chyba při odeslání e-mailu. Zkuste to prosím později. ${e}`)
      });
    },
    triggerPhoneNumberVerification: function (numIndex) {
      this.showVerifyPhoneNumberIdx = numIndex;
      $('#tajnej').focus()
    },
    finishedPhoneNumberVerification: function () {
      this.showVerifyPhoneNumberIdx = null;
      this.load();
    },
    successfulPhoneNumberVerification: function () {
      alert('V pořádku. Děkujeme za ověření telefonního čísla.')
    }
  }
}

</script>
<style>
.row {
  margin-top: 1em;
  margin-bottom: 1em;
}
#grey-note {
  color: grey;
}
.monospace {
  font-family: monospace;
}
button.btn-outline-primary:disabled {
  color: gray;
  border-color: gray;
}

#tajnej {
  position: fixed;
  left: 0px;
  top: 0px;
  border-width: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
  height: 0;
  width: 0;
}

</style>



// WEBPACK FOOTER //
// PersonalDetails.vue?31f6b5c4